import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { LoadingSpinner } from './LoadingSpinner';

const ALLOWED_USER_ID = 'OR37iKb1oxMw1MjwptcCqSqAfNU2';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

export function ProtectedRoute({ children }: ProtectedRouteProps) {
  const { currentUser, loading } = useAuth();

  if (loading) {
    return <LoadingSpinner message="Loading..." />;
  }

  if (!currentUser) {
    return <Navigate to="/" replace />;
  }

  if (currentUser.uid !== ALLOWED_USER_ID) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
} 